import { Helmet } from 'react-helmet-async';
import { Button } from '../components/ui/Button.jsx';

/**
 * 500. Says what happened, that we know, and what is still usable — which is
 * more useful to a customer than an apology.
 */
export const ServerError = ({ onRetry }) => (
  <>
    <Helmet>
      <title>Something went wrong — Golden Era</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <section className="mx-auto grid min-h-[70vh] max-w-(--container-content) place-items-center px-6">
      <div className="max-w-lg text-center">
        <p className="font-mono text-2xs tracking-[0.16em] text-muted uppercase">Error</p>
        <h1 className="mt-3 font-display text-3xl tracking-[-0.02em] text-ink">
          We could not load that
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-muted">
          Something failed on our side and we have been told about it. Nothing you did caused this,
          and nothing in your bag has been lost.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          <Button onClick={onRetry ?? (() => window.location.reload())}>Try again</Button>
          <Button to="/" variant="outline">
            Back to the shop
          </Button>
        </div>
      </div>
    </section>
  </>
);

export default ServerError;
